import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { AuthData, withAuthContext } from '../context/auth';
import { PolicyQuoteResponse } from '../types/policy';
import { getComparator, HeadCell, Order, stableSort } from '../util/tableUtil';
import { capitalize } from '../util/util';
import { StyledEmptyMessage } from './common/index';
import SortableTable from './SortableTable';

interface Props {
	quotes: PolicyQuoteResponse[];
	authData: AuthData;
}

interface Data {
	name: string;
	dateCreated: string;
	status: string;
}

function createData(name: string, dateCreated: string, status: string): Data {
	return { name, dateCreated, status };
}

const HistoricalQuotesTable = (props: Props) => {
	const { quotes, authData } = props;
	const [order, setOrder] = React.useState<Order>('asc');
	const [orderBy, setOrderBy] = React.useState<string>('name');

	const emptyTable = !quotes.length ? (
		<StyledEmptyMessage>No Historical Quotes</StyledEmptyMessage>
	) : null;

	const headCells: HeadCell[] = [
		{ id: 'name', rightAlign: false, label: 'Quote Name' },
		{ id: 'dateCreated', rightAlign: false, label: 'Date Created' },
		{ id: 'status', rightAlign: false, label: 'Status' },
	];

	const rows: any = quotes.map((quote: any, index: number) => {
		return createData(
			quote.name,
			quote.createdTimestamp,
			capitalize(quote.state),
		);
	});

	const rowElements = stableSort(rows, getComparator(order, orderBy)).map(
		(row: any, index: number) => {
			return (
				<TableRow hover tabIndex={-1} key={`quote-${index}`}>
					<TableCell scope='row'>{row.name}</TableCell>
					<TableCell>{authData.getFormattedDate(row.dateCreated)}</TableCell>
					<TableCell>{row.status}</TableCell>
				</TableRow>
			);
		},
	);

	return (
		<SortableTable
			rows={rowElements}
			headCells={headCells}
			additionalMsg={emptyTable}
			order={order}
			setOrder={setOrder}
			orderBy={orderBy}
			setOrderBy={setOrderBy}
		/>
	);
};

export default withAuthContext<Props>(HistoricalQuotesTable);
